import React from "react";
import styles from "./../CompleteProfile.scss";

export const AddButton = props => {
  const { fields, addText } = props;

  return (
    <button
      type="button"
      onClick={() => fields.push({})}
      style={{
        backgroundColor: "transparent",
        color: "#70adcc",
        border: 0,
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        padding: 0,
        marginBottom: 10
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        style={{ margin: "5px" }}
      >
        <path
          fill="none"
          fillRule="evenodd"
          stroke="#70ADCC"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M8.999 1A7.997 7.997 0 0 0 1 8.999 8.001 8.001 0 1 0 8.999 1zm0 3.361v9.277M4.362 9h9.277"
        />
      </svg>
      <div className={styles.addText}>{addText}</div>
    </button>
  );
};



// WEBPACK FOOTER //
// ./src/routes/candidate/completeProfile/components/AddBox/AddButton.js